import {useIsMobile} from '@continuum/ui/hooks';

const SM_BREAKPOINT = 640;
const LG_BREAKPOINT = 1024;

// Viewport gates, unrelated to the main app's platform useIsDesktop.
export function useIsDesktop() {
  return !useIsMobile(SM_BREAKPOINT);
}

export function useIsLargeDesktop() {
  return !useIsMobile(LG_BREAKPOINT);
}
